import { useMatchRoute } from "@tanstack/react-router";
import { menuItems } from "../helpers/navigationHelpers";

export const useActiveLink = () => {
  const matchRoute = useMatchRoute();
  return menuItems.find((item) => matchRoute({ to: item.link, fuzzy: true }));
};
